import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountStateEnum, AumicoUserDTO } from '@modeso/types__aumico-lib-users-be';
import Debug from 'debug';

const debug = Debug('aumico:admin:ActivateUserComponent');
@Component({
    selector: 'app-activate-user',
    templateUrl: './activate-user.component.html',
    styleUrls: ['./activate-user.component.scss'],
})
export class ActivateUserComponent {
    isViewMode: boolean;
    userData: AumicoUserDTO;
    errorMessage;
    constructor(
        private dialogRef: MatDialogRef<ActivateUserComponent, string | null>,
        @Inject(MAT_DIALOG_DATA) public data: AumicoUserDTO,
    ) {
        this.userData = this.data;
        this.isViewMode = this.data.state === AccountStateEnum.ACCESSREQUESTED;
    }

    closeDialog() {
        this.dialogRef.close(null);
    }

    onSubmit(): void {
        this.dialogRef.close(this.userData.userId as unknown as string);
    }
}
